import {io} from 'socket.io-client';
import {SOCKET_BASE_URI} from "./utils/services";

export const socket = io(SOCKET_BASE_URI, {
  autoConnect: false
});
